import type { SVGProps } from 'react';

const SvgChecked = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 22 22' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <rect width={22} height={22} rx={4} fill='#152348' />
    <path
      d='M6 11L9.33333 14.5L16 7.5'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgChecked;
